module.exports = __webpack_public_path__ + "static/media/tiktok-logo-icon.b7f7cdd1.svg";